module.exports = __webpack_public_path__ + "static/media/full-screen-exit.c76c4b80.svg";